import { Fragment } from 'react';
import PageHeader from '@components/PageHeader/PageHeader';

export default function BiDashboard() {
    return (
        <Fragment>
            <PageHeader breadcrumb={[]}>首页</PageHeader>
            <div className="page-route-body">
                <div className="main-content-title">快捷入口</div>
            </div>
        </Fragment>
    );
}
